import { createGrid, themeQuartz } from 'ag-grid-community'
import { makeColumnDefs } from './make-column-defs.js'
import { makeRows } from './make-rows.js'

export function showTableSyncs (apiResponse) {
  // console.log('showTableSyncs', apiResponse)

  const rows = makeRows(apiResponse)
  // console.log('rows', rows)

  const columnDefs = makeColumnDefs(apiResponse)
  console.log('columnDefs', columnDefs)

  const gridOptions = {
    rowData: rows,
    columnDefs,
    defaultColDef: {
      filter: true,
      floatingFilter: true
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
    },
    getRowId: (cellParams) => cellParams.data.data_sync_id,
    onCellClicked: function (cellParams) {
      console.log('onCellClicked', cellParams)
    },
    theme: themeQuartz
  }

  const containerId = 'entityGrid'
  const gridContainerElement = document.getElementById(containerId)
  console.log('gridContainerElement', gridContainerElement)
  const gridApi = createGrid(gridContainerElement, gridOptions)
  console.log('grid created', gridApi)
}
